import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { MessageDetails } from '../types/MessageDetails';

export const useGetMessage = (notificationQueueID: number | undefined) => {

    const { data, isLoading } = useQuery({
        queryKey: ['message', notificationQueueID],
        enabled: !!notificationQueueID,
        queryFn: async () => await apiClient.get('communication/message',
            { params: { notificationQueueID: notificationQueueID } }) as MessageDetails
    });

    return {
        data,
        isLoading
    };
};
